import { Directive, ElementRef, HostListener, OnDestroy } from '@angular/core';
import { RsMotionService } from './rs-motion';

/**
 * Paints the design-system ripple inside `.rs-btn`-style controls on press.
 * Visual only — the click still reaches the host's own handlers untouched.
 */
@Directive({
  selector: '[rsRipple]',
  standalone: true,
})
export class RsRippleDirective implements OnDestroy {
  private nodes = new Set<HTMLElement>();

  constructor(private host: ElementRef<HTMLElement>, private motion: RsMotionService) {}

  @HostListener('pointerdown', ['$event'])
  onPress(event: PointerEvent): void {
    if (!this.motion.enabled) return;

    const el = this.host.nativeElement;
    const rect = el.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height) * 2.2;

    const ripple = document.createElement('span');
    ripple.className = 'rs-ripple';
    ripple.style.width = ripple.style.height = `${size}px`;
    ripple.style.left = `${event.clientX - rect.left}px`;
    ripple.style.top = `${event.clientY - rect.top}px`;

    el.appendChild(ripple);
    this.nodes.add(ripple);
    ripple.addEventListener('animationend', () => {
      ripple.remove();
      this.nodes.delete(ripple);
    });
  }

  ngOnDestroy(): void {
    this.nodes.forEach((n) => n.remove());
    this.nodes.clear();
  }
}
